import { InputRef, Input as AntInput } from 'antd';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { prop, switchProp } from 'styled-tools';
import { Short01, Text01 } from '../../styles';

export type InputType = InputRef;
export interface GhostInput {
  ghost?: boolean;
}

export const InputBackgroundColor = theme('mode', {
  light: 'var(--white-100)',
  gray: 'var(--white-100)',
});

export const InputFocus = css`
  box-shadow: none;
  outline-color: var(--scarlet-gray-100);
  outline-offset: -2px;
`;

export const InputBorder = css`
  outline: 2px solid;
  outline-color: transparent;
  outline-offset: -2px;
  border: none;
  border: 1px solid var(--field-border-default);
  border-radius: var(--border-radius-small);
`;

export const HeightStyle = css`
  ${switchProp(prop('size', 'middle'), {
    small: 'var(--input-size-sm)',
    middle: 'var(--height-base)',
    large: 'var(--height-lg)',
  })}
`;

export const Height = css`
  height: ${HeightStyle};
`;

export const BackgroundColor = css`
  background-color: var(--white-100);
  background-color: ${InputBackgroundColor};
`;

export const InputStyle = css`
  margin: 0;
  width: 100%;
  padding: 0 var(--spacing-04);
  ${InputBorder};
  ${Short01};
  ${Text01};
  ${BackgroundColor};
  ${Height};
  &:focus {
    ${InputFocus};
  }
  &:hover {
    border-color: var(--field-border-hover);
  }
`;

export const Input = styled(AntInput)`
  ${InputStyle};
  color: var(--text-primary);

  &.ant-input-disabled {
    color: var(--text-disabled);
  }

  &.ant-input-affix-wrapper {
    &.ant-input-affix-wrapper-disabled {
      opacity: 0.5;
    }

    &:focus,
    &.ant-input-affix-wrapper-focused {
      ${InputFocus};
    }

    .ant-input {
      color: var(--text-primary);
      background-color: transparent;
    }
  }
`;
